import axios from "../../../config/axiosConfig";

export const getOpcionesEmparejamiento = (codServicioCliente) =>
  axios.get(`/api/emparejamiento/opciones/${encodeURIComponent(codServicioCliente)}`);

export const guardarEmparejamiento = (payload) =>
  axios.post("/api/emparejamiento/guardar", payload);
